export const LIST_PAGE_TEST_ID = 'ListPage';
export const LIST_SECTION_TEST_ID = 'ListSection';
export const ONBOARDING_BANNER_TEST_ID = 'OnboardingBanner';
export const LIST_PAGE_LOADING_TEST_ID = 'ListPageLoading';
export const LIST_PLACEHOLDER_TEST_ID = 'ListPlaceholder';
